export default __webpack_public_path__ + "static/media/GRILLER.f0da906e.jpg";